import { AppointmentFormFieldData } from 'components/mrp/components/AppointmentForm/AppointmentForm.types';
import { createAppointmentFormDataFromEventResponse } from 'components/mrp/components/Calendar/components/CalendarAppointment/CalenderAppointment.utils';
import { EventResponse, PlanningEntityIdentifier } from 'generated/index';

export const addEntityToEvent = ({
  event,
  entity
}: {
  event: EventResponse;
  entity: PlanningEntityIdentifier;
}): AppointmentFormFieldData => {
  const formData = createAppointmentFormDataFromEventResponse(event)!;

  formData.editAppointmentType = null;
  if (formData.isRecurring && formData.recurrencePattern) {
    formData.originalOccurrenceStart = formData.start;
  }

  switch (entity.planningEntityType) {
    case 'CLIENT':
      formData.planEntities.CLIENT.push({ ...entity, label: '' });
      break;
    case 'EMPLOYEE':
      formData.planEntities.EMPLOYEE.push({ ...entity, label: '' });
      break;
    case 'RESOURCE':
      formData.planEntities.RESOURCE.push({ ...entity, label: '' });
      break;
    case 'WORKPLACE':
      // Formconversion provides a placeholder for workplace, which
      // we don't want. We fully replace the array instead, since
      // workplaces can only have 1 entry anyway.
      formData.planEntities.WORKPLACE = [{ ...entity, label: '' }];
      break;
  }

  return formData;
};
